import Axios, { AxiosInstance } from "axios";
import AchievementController from "./Controllers/Achievement/achievementController";

export interface IGamificationApiClientConfig {
    url: string;
    countryCode: string;
    getCookie: (n: string) => string;
}

export default class GamificationApiClient {
    private httpClient: AxiosInstance;
    private config: IGamificationApiClientConfig;
    constructor(config: IGamificationApiClientConfig) {
        this.httpClient = Axios.create({
            baseURL: config.url,
        });

        this.config = config;
    }

    public get Achievements() {
        return new AchievementController(this.httpClient, this.config);
    }
}
